import React from 'react';

import ActionButton from '../ActionButton/ActionButton';
import SavePendingChangesButton from '../SavePendingChangesButton';

export const renderTopLevelAction = ({
  actionData,
  executingActionId,
  disabledLoanActionsSet,
  runningLoanActionsSet,
  onConfirmLoanAction,
  onLoanActionClick,
}) => {
  const isDisabled =
    executingActionId === actionData.id || disabledLoanActionsSet.has(actionData.id);
  const isRunning = runningLoanActionsSet.has(actionData.id);

  if (actionData.isHasSavePendingChangesAction) {
    return (
      <SavePendingChangesButton
        actionData={actionData}
        isDisabled={isDisabled}
        key={actionData.id}
        onClick={onConfirmLoanAction}
        onExecuteLoanAction={onLoanActionClick}
      />
    );
  }

  return (
    <ActionButton
      color={actionData.color}
      dataId={actionData.id}
      disabled={isDisabled}
      icon={actionData.icon}
      isRunning={isRunning}
      key={actionData.id}
      name={actionData.name}
      variant={actionData.variant}
      onClick={onConfirmLoanAction}
    >
      {actionData.name}
    </ActionButton>
  );
};
